/* It renders the contents of the cart notification,
opens the notification, and closes the notification */
class CartNotification extends HTMLElement {
  /**
   * The constructor function is a special function that is called when an object is created from a
   * class
   */
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  /**
   * When the notification is opened, add the animate and active classes to the notification element,
   * and then add a transitionend event listener to the notification element that will focus the
   * notification element and trap focus inside it
   */
  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  /**
   * It removes the active class from the notification, removes the event listener from the body, and
   * removes the trap focus
   */
  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  /**
   * It takes the parsedState object, which is the JSON object returned from the server, and it renders
   * the contents of the cart
   * @param parsedState - The parsed state object that was returned from the server.
   */
  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  /**
   * It returns an array of objects that contain the id of the section to render and the selector of
   * the element to render the section into
   * @returns An array of objects.
   */
  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  /**
   * It takes a string of HTML, parses it into a DOM, and returns the innerHTML of the first element
   * that matches the selector
   * @param html - The HTML string that you want to parse.
   * @param [selector=.shopify-section] - The selector to use to find the section.
   * @returns The innerHTML of the first element that matches the selector.
   */
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  /**
   * If the target of the click event is not the notification element and the target is not a child of
   * the notification element, then close the notification
   * @param evt - The event object that was triggered.
   */
  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  /**
   * It sets the activeElement property of the component to the element that was passed in
   * @param element - The element to set as active.
   */
  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);